import React from '../helpers/react'
import { Provider } from 'react-redux'
import { Router } from 'react-router'

const PropTypes = React.PropTypes;

const Root = React.createClass({
    render() {
        const { store } = this.props

        return <Provider store={store}>
                <Router history={this.props.history}>
                    {this.props.routes}
                </Router>
            </Provider>
    }
})

Root.propTypes = {
    store :  PropTypes.object.isRequired
}

export default Root


// WEBPACK FOOTER //
// ./src/containers/Root.js